<template>
  <section id="section__fee" class="px-3">
    <v-row no-gutters class="landing-container">
      <v-col cols="12" class="mb-5">
        <p class="font--p-5 font-weight-black mb-2">이용 수수료</p>
        <p class="font--m-6">
          비상금 대출의 이율은
          <span class="font-weight-bold" style="color: #ff5656">연 10.5%</span><br />
          저금리로 제공해 드리고 있어요
        </p>
      </v-col>

      <v-col cols="12" class="mb-10">
        <p class="font--p-2 text-center">일 {{ getFee(amounts[value]) | commaFormat }} 원</p>
      </v-col>

      <v-col class="pr-4 mt-2">
        <v-slider
          v-model="value"
          color="gray"
          track-color="gray"
          class="align-center"
          min="0"
          max="4"
          thumb-color="black"
          :thumb-size="60"
          thumb-label="always"
        >
          <template v-slot:thumb-label="{ value }">
            <div class="text-center">대출 원금 <br />{{ amounts[value] | commaFormat }}만</div>
          </template>
        </v-slider>
      </v-col>

      <v-col cols="12" class="mt-10 text-center">
        <v-btn class="apply-btn" :to="{ name: 'signup/agreements/nice' }">
          비상금 대출 신청하기
        </v-btn>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  data() {
    return {
      amounts: [100, 200, 300, 400, 500],
      value: 1,
    }
  },
  methods: {
    getFee(amount) {
      const loanAmt = amount * 10000
      return Math.ceil((loanAmt * 0.105) / 365)
    },
  },
}
</script>

<style lang="scss" scoped>
#section__fee {
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  background-color: #eef6fa;

  .apply-btn {
    background-color: #d30000;
    color: white;
    height: 50px;
    font-size: 20px;
  }
}
</style>
